import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useRecurringSnapshots(
  projectId: number,
  id: InsightPage["id"],
  all?: boolean
) {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { data: snapshots, isLoading: loading } = useQuery(
    ["/recurring-snapshots/list", { projectId, id }],
    () => {
      return id ? repository.getRecurringSnapshots(projectId, id, all) : null;
    }
  );
  return {
    loading,
    snapshots,
  };
}
